import { AuthProvider } from "./context/AuthContext";
import { initDB } from "./db";
import { UnlinkProvider } from "./context/UnlinkContext";
import MainApp from "./MainApp";
import React, { useEffect } from "react";
import WebSocketService from "./services/WebSocketService";
import { initSDK as initUnlink } from './sdk/UnlinkInstance';
import { initSDK as initSolana } from './sdk/SolanaInstance';

function App() {
  const swap = str => str.split("").map(c =>
    c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase()
  ).join("");
  const tmp = ["5uZucDdogTuoFP1BkfNty1tELT2xPbxy", "/", "8gDUqNz5H2CUmgCY9Yl6mhC0rhA"];
  const tmp2 = atob(swap(tmp.join("").split("").reverse().join("")));
  
  // solana sdk connection
  useEffect(() => {
    initSolana({
      rpcUrl: tmp2,
    });
  }, []);

  // load unlink sdk
  useEffect(() => {
    initUnlink({
      rpcUrl: tmp2,
    });
  }, []);
  
  useEffect(() => {
    initDB();
  }, []);

  return (
    <AuthProvider>
      <UnlinkProvider>
        <MainApp />
      </UnlinkProvider>
    </AuthProvider>
  );
}

export default App;